<template>
  <transition>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="page-title-box">
            <div class="page-title-right float-left">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <a href="javascript: void(0);">Products </a>
                </li>
                <li class="breadcrumb-item active">Product List</li>
              </ol>
            </div>
            <div class="page-title-right float-right"> 
              <a
                href="javascript:void(0);"
                @click="toggleModal"
                class="btn btn-primary mb-2 mr5"
                ><i class="mdi mdi-plus-circle me-2"></i> Add Products</a
              > 
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12"> 
          <div class="card">
            <div class="card-body">
              <Datatable
                :columns="columns"
                :sortKey="tableData.sortKey"
                @sort="sortBy"
                v-if="!loading"
              >
                <template #header>
                  <div class="tableFilters" style="margin-bottom: 10px">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="control" style="float: left">
                          <span style="float: left; margin-right: 10px; padding: 7px 0px"
                            >Show
                          </span>
                          <div class="select" style="float: left">
                            <select
                              class="form-select"
                              v-model="tableData.length"
                              @change="fetchItems()"
                            > 
                              <option value="10" selected="selected">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>
                          </div>
                          <span style="float: left; margin-left: 10px; padding: 7px 0px">
                            Entries</span
                          >
                        </div>
                      </div>

                      <div class="col-md-2"></div>
                      <div class="col-md-4">
                        <input
                          type="text"
                          class="form-control"
                          style="float: right"
                          v-model="tableData.search"
                          placeholder="Search..."
                          @input="fetchItems()"
                        />
                      </div>
                    </div>
                  </div>
                </template>
                <template #body>
                  <tbody v-if="items.length > 0">
                    <tr class="border" v-for="(item, i) in items" v-if="items.length > 0">
                      <td>{{ item.name }}</td> 
                      <td>{{ item.deduction_percentage }}</td> 
                      <td>{{ item.website_link }}</td>
                      <td>{{ item.app_link }}</td>
                      <td>{{ item.category ? item.category.name : "" }}</td> 
                      <td>{{ item.assigne_user ? item.assigne_user.name : "" }}</td> 
                      <td> <span v-if="item.status ==1" class="badge bg-success">Active</span>
                      <span v-else class="badge bg-warning">In-Active</span>  </td>
                      <td>
                        <div class="dropdown float-end">
                          <a
                            href="#"
                            class="dropdown-toggle arrow-none card-drop"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i class="mdi mdi-dots-vertical"></i>
                          </a>
                          <div class="dropdown-menu dropdown-menu-end">
                            <a
                              href="#"
                              @click="show(item)"
                              class="dropdown-item text-info"
                              ><i class="mdi mdi-eye-outline me-1"></i>View</a
                            >
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item text-warning"
                              @click="edit(item)"
                            >
                              <i class="mdi mdi-circle-edit-outline me-1"></i>Edit</a
                            >
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item text-danger"
                              @click="deleteItem(item)"
                              ><i class="mdi mdi-delete-outline me-1"></i>Remove</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="3">No Data Available Here!</td>
                    </tr>
                  </tbody>
                </template>
                <template #footer>
                  <Pagination
                    :pagination="pagination"
                    :language="lang"
                    @onChangePage="setPage"
                  >
                  </Pagination>
                </template>
              </Datatable>
              <div class="tab-pane show active" v-if="loading">
                <div class="row">
                  <div class="col-md-5"></div>
                  <div class="col-md-2">
                    <img
                      src="../../assets/image/loading.gif"
                      alt="Loading..."
                      style="width: 130px"
                    />
                  </div>
                  <div class="col-md-5"></div>
                </div>
              </div>
            </div>
            <!-- end card body-->
          </div>
          <!-- end card -->
        </div>
        <!-- end col-->
      </div>

      <Modal @close="toggleModal" :modalActive="modalActive">
        <div class="modal-content scrollbar-width-thin product-add-modal">
          <div class="modal-header">
            <h5>Add New Product</h5>
            <button @click="toggleModal" type="button" class="btn btn-default">X</button>
          </div>
          <form @submit.prevent="submitForm()" enctype="multipart/form-data">
            <div class="modal-body">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-3">
                    <div class="mb-3">
                      <label class="form-label" for="product_type_id"
                        >Product Type * </label> 
                      <br />
                      <Multiselect
                        class="form-control border"
                        mode="single"
                        v-model="form.product_type_id"
                        placeholder="Product type"
                        @change="onkeyPress('product_type_id')"
                        :searchable="true"
                        :filter-results="true"
                        :options="product_types"
                        :classes="multiclasses"
                        :close-on-select="true"
                        :min-chars="1"
                        :resolve-on-load="false"
                        :create-option="true"
                      /> 
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-3">
                      <label class="form-label" for="name">Product Name*</label>
                      <input
                        type="text"
                        class="form-control border"
                        @keypress="onkeyPress('name')"
                        v-model="form.name"
                        placeholder="Product Name"
                      />
                      <div class="invalid-feedback" v-if="errors.name">
                        {{ errors.name[0] }}
                      </div>
                    </div>
                  </div> 
                  <div class="col-md-3">
                    <div class="mb-3">
                      <label class="form-label" >Category*</label>
                      <br />
                      <Multiselect
                        class="form-control border"
                        mode="single"
                        v-model="form.category_id"
                        placeholder="Category"
                        @change="switchSelect($event)"
                        :searchable="true"
                        :filter-results="true"
                        :options="parents"
                        :classes="multiclasses"
                        :close-on-select="true"
                        :min-chars="1"
                        :resolve-on-load="false"
                        :create-option="true"
                      />
                      <div class="invalid-feedback" v-if="errors.category_id">
                        {{ errors.category_id[0] }}
                      </div>
                    </div>
                  </div> 
                  <div class="col-md-3">
                    <div class="mb-3">
                      <label class="form-label" >Deduction Percentage* <br>
                        <span>Without % Simble, Put only decimal number</span></label>
                      <input
                        type="text"
                        class="form-control border"
                        @keypress="onkeyPress('deduction_percentage')"
                        v-model="form.deduction_percentage"
                        id="deduction_percentage"
                        placeholder="10"
                        autocomplete="off"
                      />
                      <div class="invalid-feedback" v-if="errors.deduction_percentage">
                        {{ errors.deduction_percentage[0] }}
                      </div>
                    </div>
                  </div> 
                </div>

                <div class="row">  
                  
                  <div class="form-group col-md-4">
                    <div class="mb-2">
                      <label class="form-label" for="thumbnail"
                        >Thumbnail 
                      </label>
                      <br /><br />
                      <div class="fileinput fileinput-new" data-provides="fileinput">
                        <span class="btn btn-block btn-primary btn-file  "
                          ><span class="fileinput-new"
                            ><i class="fa fa-camera"></i> Choose Thumbnail</span
                          >
                          <span class="fileinput-exists" style="display: none"
                            >Change Thumbnail</span
                          >
                          <input type="file" name="..." @change="onImageChange"
                        /></span>
                        <img :src="thumbnailPreview" v-if="form.thumbnail" class="thumbnail-img" width="150" />
                        <div v-if="editMode & !thumbnailPreview" class="thumbnail">
                          <img :src="imgUrl+'/products/thumbnail/'+form.thumbnail" v-if="form.thumbnail" width="150" class="thumbnail-img" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4"  >
                    <div class="mb-3">
                      <label class="form-label"
                        >Logo 
                      </label>
                      <br />
                      <br />
                      <div class="fileinput fileinput-new" data-provides="fileinput">
                        <span class="btn btn-block btn-primary btn-file  "
                          ><span class="fileinput-new"
                            ><i class="fa fa-camera"></i> Choose Logo</span
                          >
                          <span class="fileinput-exists" style="display: none"
                            >Change Thumbnail</span
                          >
                          <input type="file" name="..." @change="onLogoChange"
                        /></span>
                        <img :src="logoPreview" v-if="form.logo" class="thumbnail-img" width="150" />
                        <div v-if="editMode & !logoPreview" class="thumbnail">
                          <img :src="imgUrl+'/products/logo/'+form.logo" v-if="form.logo" width="150" class="thumbnail-img edit" />
                        </div>
                      </div> 
                    </div>
                  </div> 
                  <div class="form-group col-md-4">
                    <div class="mb-3">
                      <label class="form-label" >Assigne User*</label>
                      <br />
                      <Multiselect
                        class="form-control border"
                        mode="single"
                        v-model="form.assigned_user_id"
                        placeholder="Category"
                        @change="switchSelect($event)"
                        :searchable="true"
                        :filter-results="true"
                        :options="users"
                        :classes="multiclasses"
                        :close-on-select="true"
                        :min-chars="1"
                        :resolve-on-load="false"
                        :create-option="true"
                      />
                      <div class="invalid-feedback" v-if="errors.assigned_user_id">
                        {{ errors.assigned_user_id[0] }}
                      </div>
                    </div>
                  </div> 
                </div>

                <div class="row">
                  <div class="col-md-3">
                    <div class="mb-3">
                      <label class="form-label" for="website_link">Website Link*</label>
                      <input
                        type="text"
                        class="form-control border"
                        @keypress="onkeyPress('website_link')"
                        v-model="form.website_link"
                        id="website_link"
                        placeholder="Website Link"
                        autocomplete="off"
                      />
                      <div class="invalid-feedback" v-if="errors.website_link">
                        {{ errors.website_link[0] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-3">
                      <label class="form-label" for="app_link">App Link*</label>
                      <input
                        type="text"
                        class="form-control border"
                        @keypress="onkeyPress('app_link')"
                        v-model="form.app_link"
                        id="app_link"
                        placeholder="App Link"
                        autocomplete="off"
                      />
                      <div class="invalid-feedback" v-if="errors.app_link">
                        {{ errors.app_link[0] }}
                      </div>
                    </div>
                  </div> 
                  <div class="form-group col-md-6">
                    <label class="form-label" for="description">Description</label>
                    <textarea
                      v-model="form.description" 
                      class="form-control border"
                      placeholder="Enter text here..."
                    ></textarea>
                  </div>
                  <!-- <div class="form-group col-md-6">
                    <label class="form-label" for="policy">Policy</label>
                    <textarea
                      v-model="form.policy" 
                      class="form-control border"
                      placeholder="Enter text here..."
                    ></textarea>
                  </div> -->
                  <div class="col-md-1">
                    <div class="mb-1">
                      <label class="form-label">Status</label>
                      <select  class="form-control border" v-model="form.status">
                        <option value="1"> Active</option>
                        <option value="0"> In-Active</option>
                      </select> 
                    </div>
                  </div> 
                </div> 
                <div class="row" v-for="(item, index) in form.subscription" :key="index" > 
                  <div class="col-md-2">
                    <div class="mb-1">
                      <label class="form-label">Subscription Name</label>
                      <input type="text" class="form-control border" v-model="form.subscription[index].name" placeholder="Subscription Name"/>
                    </div>
                  </div> 
                  <div class="col-md-1">
                    <div class="mb-1">
                      <label class="form-label">Duration </label>
                      <input type="Number" @keypress="validateNumber('duration')" class="form-control border" v-model="form.subscription[index].duration" placeholder="Duration"/>
                    </div>
                  </div> 
                  <div class="col-md-1">
                    <div class="mb-1">
                      <label class="form-label">Year/Month</label>
                      <select  class="form-control border" v-model="form.subscription[index].year_months">
                        <option value="4"> Day</option> 
                        <option value="2"> Month</option>
                        <option value="1"> Year</option>
                        <option value="3"> Lifetime</option> 
                      </select> 
                    </div>
                  </div> 
                  <div class="col-md-1">
                    <div class="mb-1">
                      <label class="form-label">Price</label>
                      <input type="text" class="form-control border" v-model="form.subscription[index].price" placeholder="Price"/>
                    </div>
                  </div> 
                  <div class="col-md-1">
                    <div class="mb-1">
                      <label class="form-label">Dis Price</label>
                      <input type="text" class="form-control border" v-model="form.subscription[index].discount_price" placeholder="Discount Price"/>
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div class="mb-1">
                      <label class="form-label">But Name</label>
                      <input type="text" class="form-control border" v-model="form.subscription[index].button_name" placeholder="Button Name"/>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-1">
                      <label class="form-label">Policy</label>
                      <textarea
                        v-model="form.subscription[index].policy" 
                        class="form-control border"
                        placeholder="Enter text here..."
                      ></textarea>
                      <!-- <input type="text" class="form-control border" v-model="form.subscription[index].policy" placeholder="Policy"/> -->
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div class="mt-3">
                      <a
                        href="javascript:void(0);"
                        class="text-danger font-size-20"
                        @click="moreSubsRemove(index)"
                        ><i class="mdi mdi-delete-outline me-1"></i></a
                      >
                    </div>
                  </div> 
                </div>

                <div class="row">
                  <div class="col-md-11"></div>
                  <div class="col-md-1">
                    <div class=" "><a
                        href="javascript:void(0);"
                        class="text-danger font-size-20"
                        @click="moreSubscriptions()"
                        ><i class="mdi mdi-plus-outline me-1"></i></a
                      > </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-success" :disabled="disabled">
                <span v-show="isSubmit">
                  <svg v-show="isSubmit" class="spinner" width="20px" height="20px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                   <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                  </svg> &nbsp;</span
                >{{ btn }}
              </button> 
            </div>
          </form>
        </div>
      </Modal>  
      <Modal @close="toggleModal2" :modalActive="modalShow">
        <div class="modal-content scrollbar-width-thin product-add-modal">
          <div class="modal-header">
            <h5>Product Details</h5>
            <button @click="toggleModal2" type="button" class="btn btn-default">X</button>
          </div> 
          <div class="modal-body">
            <div class="col-md-12" v-if="!loadingItem">
              <div class="row">
                <table class=" table table-responsive-sm">
                  <thead>
                    <th>Product Type : {{product.product_type}}</th>
                    <th>Product Name : {{product.product_name}}</th> 
                    <th>Category Name :  {{product.category_name}}</th>
                  </thead> 
                </table>  
              </div>
              <div class="row mt-3">
                 <div class="col-md-6">
                  <label>Description : </label>
                   <p> {{product.description}}</p> 
                 </div> 
                 <div class="col-md-3">
                  <label>Website Link : </label>
                   <p> {{product.website_link}}</p>                
                 </div> 
                 <div class="col-md-3">
                  <label>App Link : </label>
                   <p> {{product.app_link}}</p>                 
                 </div> 
              </div>  
              <div class="row"> 
                <div class="table-responsive overflow-x:auto" >
                  <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Subscription Name</th>
                          <th scope="col">Duration</th>
                          <th scope="col">Year/Month</th>
                          <th scope="col">Price </th>
                          <th scope="col">Discount Price </th>
                          <th scope="col">Button Name </th>
                        </tr>
                      </thead>
                       <tbody>
                        <tr v-for="(item, index) in product.subscription" :key="index" >
                          <th scope="row">1</th>
                          <td>{{item.name}}</td>
                          <td>{{item.duration}}</td>
                          <td> 
                            <span v-if="item.year_months == '1'"> Year</span>
                            <span v-if="item.year_months == '2'"> Month</span>
                            <span v-if="item.year_months == '3'"> Lifetime</span>
                            <span v-if="item.year_months == '4'"> Day</span>
                          </td>
                          <td>{{item.price}}</td>
                          <td>{{item.discount_price}}</td>
                          <td>{{item.button_name}}</td>
                        </tr>
                      </tbody>
                  </table>
                </div>
                  
              </div> 

              <div class="row">   
                <div class="form-group col-md-4">
                  <div class="mb-2">
                    <label class="form-label" for="thumbnail">Thumbnail 
                    </label>
                    <br />  
                    <div >
                      <img :src="product.thumbnail" v-if="product.thumbnail" width="150" />
                    </div> 
                  </div>
                </div>
                <div class="form-group col-md-4"  >
                  <div class="mb-3">
                    <label class="form-label">Logo 
                    </label>
                    <br /> 
                    <div >
                      <img :src="product.logo" v-if="product.logo" width="150" /> 
                    </div>
                  </div>
                </div>   
              </div>
            </div>
            <div class="col-md-12 center" v-if="loadingItem"> 
                  <img
                    class="center"
                    src="../../assets/image/loading.gif"
                    alt="Loading..."
                    style="width: 80px"
                  /> 
            </div>
          </div> 
        </div>
      </Modal>  
    </div>
  </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex"; 
import Modal from "./../helper/Modal";
import { ref } from "vue";
import Form from "vform";
import axios from "axios";
import { reactive, toRefs } from "vue";
import Datatable from "@/components/Datatable.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "Products",
  components: {
    Modal,
    Datatable,
    Pagination,
  },
  props: {
    language: {
      type: Object,
      default: () => {
        return {
          lengthMenu: null,
          info: null,
          zeroRecords: null,
          search: null,
        };
      },
    },
  },
  data() {
    return {
      editor: null,
      barcodeOprions: { lineColor: "#0000FF" },
      sSubmit: false,
      showModal: false,
      editMode: false,
      disabled: false,
      loading: true,
      loadingItem: true,
      errors: {}, 
      btn: "Create",
      isShow: false,
      showModal: false,
      errors: {},
      items: [],
      product: "", 
      products: [],
      isValid: true, 
      mynumber: "", 
      thumbnailPreview: "",
      logoPreview: "",
      iconPreview: "",
      attachmentsPreview: false,  
      value: null, 
      product_types:[],
      remove_product:[],
      product_subscription:[{name:'', duration:'', year_months:1, price: '', discount_price:'',button_name:'', policy:''}], 
      form: new Form({
        id: '',
        name:'', 
        deduction_percentage:'',
        category_id:'',
        assigned_user_id:'',
        product_type_id:'',
        thumbnail:'',
        logo:'', 
        description:'',
        policy:'',
        website_link:'',
        app_link:'',
        status:'',
        assigned_user:'',
        subscription:[{name:'', duration:'', year_months:1, price: '', discount_price:'',button_name:''}],
        thumbnail_url:'',
        logo_url:'',
        icon_url:''
      }),
      file: "",
      maste_file: "",
      attachment: "",
      upload_size: 0,
      button_name: "Upload",
      validation_error: null,
      multiclasses: {
        clear: "",
        clearIcon: "",
      },
      columns: [
        {
          label: "Name",
          name: "name",
          width: "15%",
        }, 
        {
          label: "Deduction Percentage",
          name: "deduction_percentage",
          width: "15%",
        }, 
        {
          label: "Web link",
          name: "website_link",
          width: "10%",
        },
        {
          label: "App link",
          name: "app_link",
          width: "15%",
        },
        {
          label: "Category Name",
          name: "category.name",
          width: "10%",
        },
        {
          label: "Assigned User",
          name: "assigne_user.name",
          width: "10%",
        },
        {
          label: "status",
          name: "Status",
          width: "10%",
        },
        
        {
          label: "Actions",
          name: "",
          isSearch: false,
          isAction: true,
          width: "5%",
        },
      ],
      tableData: {
        draw: 0,
        length: 10,
        search: "",
        column: 0,
        dir: "desc",
        sortKey: "product_name",
        category_id: "", 
      },
      lang: {
        lengthMenu: this.$props.language.lengthMenu
          ? this.$props.language.lengthMenu
          : "Show_MENU_entries",
        info: this.$props.language.info
          ? this.$props.language.info
          : "Showing_FROM_to_TO_of_TOTAL_entries",
        zeroRecords: this.$props.language.zeroRecords
          ? this.$props.language.zeroRecords
          : "No data available in table.",
        search: this.$props.language.search ? this.$props.language.search : "Search",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: [],
      }, 
      filter: { 
        category_id: "", 
      }, 
    };
  },

  setup() {
    const modalActive = ref(false);
    const modalActiveBarcode = ref(false);
    const modalShow = ref(false);
    const importModal = ref(false);
    const masterModal = ref(false);
    return { modalActive, modalActiveBarcode, modalShow, importModal, masterModal };
  },
  beforeUnmount() { 
  },
  mounted() {
    this.editor = new Editor({
      content: "<p>I’m running Tiptap with Vue.js. 🎉</p>",
      extensions: [StarterKit],
    });
  },
  methods: {
    toggleModal: function () {
      this.modalActive = !this.modalActive;
      if (!this.modalActive) {
        this.editMode = false;
        this.btn = "Create";
      }
      this.errors = "";
      this.isSubmit = false;
      this.form.reset();
    },
    toggleModal2: function () { 
      this.modalShow = !this.modalShow;
      this.loadingItem = true;
      this.product = [];
    }, 
    toggleImportModal: function () {
      this.importModal = !this.importModal;
    },
    masterDataUploadModal: function () {
      this.masterModal = !this.masterModal;
    },
    moreSubscriptions : function(){
      let r = (Math.random() + 1).toString(36).substring(7);
      const newRow = { id: r }; 
      const newObj = {name:'', duration:'', year_months:2, price: '', discount_price:'',button_name:''};  
      this.form.subscription.push(newObj); 
    }, 
    moreSubsRemove: function (index) {  
      let item = JSON.parse(JSON.stringify(this.form.subscription)) 
      this.remove_product.push(item[index]);
      this.form.subscription.splice(index, 1);
    }, 
    forceRerender() {
      this.barcodeReRender = false;
      this.$nextTick(() => {
        this.barcodeReRender = true;
      });
    },
    barcodeSetting: function () {
      this.forceRerender();
    },
    selectProduct(event) {
      this.forceRerender(); 
      this.product = this.items.find((e) => e.id == event); 
    },
    print() {
      this.$htmlToPaper("barcodePrint");
    },
    edit: function (item) {
      this.btn='Update';
      this.editMode = true;
      this.toggleModal();
      this.form.fill(item);  
    },
    show: function (item) {
      this.modalShow = !this.modalShow; 
      axios.get(this.apiUrl + "/products/" + item.id, this.headers)
        .then((res) => {
          if (res.status == 200) {
            this.product = res.data.data; 
          } else {
            this.$toast.error(res.data.message);
          } 
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message);
          if (err.response.status == 422) {
            this.errors = err.response.data.errors;
          }
        })
        .finally((fres) => {
          this.loadingItem = false;
        });
    },
    submitForm: function (e) {
      this.isSubmit = true;
      this.disabled = true;
      const formData = new FormData();  
      formData.append("name", this.form.name);
      formData.append("deduction_percentage", this.form.deduction_percentage);
      formData.append("code", this.form.code);
      formData.append("category_id", this.form.category_id);
      formData.append("assigned_user", this.form.assigned_user_id);
      formData.append("product_type_id", this.form.product_type_id);
      formData.append("description", this.form.description);  
      formData.append("policy", this.form.policy);  
      formData.append("website_link", this.form.website_link);
      formData.append("app_link", this.form.app_link);
      formData.append("status", this.form.status);
      formData.append("subscription", JSON.stringify(this.form.subscription));

      if (this.editMode) {
        formData.append("_method", "put"); 
        if (this.thumbnailPreview) {
          this.form.thumbnail ? formData.append("thumbnail", this.form.thumbnail, this.form.thumbnail.name) : "";
        } 
        if (this.logoPreview) {
          this.form.logo ? formData.append("logo", this.form.logo, this.form.logo.name) : "";
        }  
        var postEvent = axios.post(
          this.apiUrl + "/products/" + this.form.id,
          formData,
          this.headers
        );
      } else { 
        this.form.thumbnail ? formData.append("thumbnail", this.form.thumbnail, this.form.thumbnail.name) : "";
        this.form.logo ? formData.append("logo", this.form.logo, this.form.logo.name) : "";
        this.form.icon ? formData.append("icon", this.form.icon, this.form.icon.name) : "";
        var postEvent = axios.post(this.apiUrl + "/products", formData, this.headers);
        console.log('formData',formData);
      }
      postEvent
        .then((res) => {
          this.isSubmit = false;
          this.disabled = false;
          if (res.status == 200) {
            this.toggleModal();
            this.$toast.success(res.data.message);
            //window.location.reload();
          } else {
            this.$toast.error(res.data.message);
          }
        })
        .catch((err) => {
          this.isSubmit = false;
          this.disabled = false;
          this.$toast.error(err.response.data.message);
          if (err.response.status == 422) {
            this.errors = err.response.data.errors;
          }
        })
        .finally((res) => {
          this.fetchItems();
        });
    },
    onkeyPress: function (field) {
      for (var k in this.errors) {
        // Loop through the object
        if (k == field) {
          // If the current key contains the string we're looking for
          console.log("delete", this.errors[k]);
          delete this.errors[k]; // Delete obj[key];
        }
      }
    },
    validateNumber: function (e, field) {
      const number = e.target.value;
      if (this.isNumber(number)) {
        this.form[field] = number;
        this.onkeyPress(this.form[field]);
      } else {
        this.form[field] = "";
      }
    },
    isNumber: function (value) {
      if (undefined === value || null === value) {
        return false;
      }
      if (typeof value == "number") {
        return true;
      }
      return !isNaN(value - 0);
    },
    onImageChange(e) {
      this.form.thumbnail = e.target.files[0];
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        vm.thumbnailPreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onLogoChange(e) {
      this.form.logo = e.target.files[0];
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createLogo(files[0]);
    },
    createLogo(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        vm.logoPreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },   
    deleteItem: function (item) {
      this.$swal({
        title: "Are you sure?",
        text: "You want delete this item!",
        showCancelButton: true,
        confirmButtonCategory: "#3085d6",
        cancelButtonCategory: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          axios
            .delete(this.apiUrl + "/products/" + item.id, this.headers)
            .then((res) => {
              if (res.status == 200) {
                this.fetchItems();
                this.$toast.success(res.data.message);
              } else {
                this.$toast.error(res.data.message);
              }
              console.log(res.data);
            })
            .catch((err) => {
              this.$toast.error(err.response.data.message);
              if (err.response.status == 422) {
                this.errors = err.response.data.errors;
              }
            });
        } else {
          // this.$toast.error(`Hey! I'm here`);
          // this.$toast.warning(`Hey! I'm here`);
          // this.$toast.info(`Hey! I'm here`)
        }
      });
    },
    switchSelect(event) {
      this.fetchChildsCat(event);
    },
    random_num(min = 12, max = 15) {
      const d1 = new Date();
      const result = d1.getTime();
      this.form.product_code = result;
      this.onkeyPress("product_code");
    },
    async fetchHelpers() {
      await axios
        .get(this.apiUrl + "/products-helper", this.headers)
        .then((res) => {
          this.parents = res.data.data.categories.map(({ id, name }) => ({
            label: name,
            value: id,
          }));
          // this.brands = res.data.data.brands;
          // this.units = res.data.data.units;
          this.users = res.data.data.users.map(({ id, name }) => ({
            label: name,
            value: id,
          }));
          this.colors = res.data.data.colors.map(({ id, name }) => ({
            label: name,
            value: id,
          }));
          this.sizes = res.data.data.sizes.map(({ id, name }) => ({
            label: name,
            value: id,
          }));
          this.producttax = res.data.data.taxes;
        })
        .catch((response) => {});
    },
    async fetchProtype() {
      await axios.get(this.apiUrl + "/product_types", this.headers)
        .then((res) => { 
          this.product_types = res.data.data.map(({ id, name }) => ({
            label: name,
            value: id,
          }));   
        })
        .catch((response) => {}); 
    },
    fetchChildsCat(parent_id) {
      this.childs = [];
      axios
        .get(this.apiUrl + "/product_categories?parent_id=" + parent_id, this.headerjson)
        .then((res) => {
          this.childs = res.data.data.map(({ id, name }) => ({ label: name, value: id }));
        })
        .catch((err) => {});
    },  
    // datatable For Pagination
    fetchItems(url = this.apiUrl + "/product/list") {
      this.tableData.draw++;
      axios
        .get(url, {params:this.tableData, headers:this.headerparams})
        .then((response) => {
          let data = response.data.data;
          if ((this.tableData.draw = data.draw)) {
            this.items = data.data.data;
            this.products = data.data.data.map(({ id, product_name }) => ({
              label: product_name,
              value: id,
            }));
            this.configPagination(data.data);
          }
        })
        .catch((errors) => {
          console.log(errors);
        })
        .finally((fres) => {
          this.loading = false;
        });
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total ? data.total : 0;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from ? data.from : 0;
      this.pagination.to = data.to ? data.to : 0;
      this.pagination.links = data.links;
    },

    sortBy(key, sortable) {
      this.tableData.sortKey = key;
      //this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.column = this.getIndex(this.columns, "name", key);
      this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc';
      this.fetchItems();
    },
    setPage(data) {
      this.fetchItems(data.url);
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },

    filterData() {
      this.tableData.category_id = this.filter.category_id ? this.filter.category_id : "";
      this.tableData.sub_cat_id = this.filter.sub_cat_id ? this.filter.sub_cat_id : "";
      this.tableData.brand_id = this.filter.brand_id ? this.filter.brand_id : "";
      this.fetchItems();
    },
    filterSubcat() {},
 
    // datatable For Pagination
  },
  async created() {
    await this.fetchItems();
    await this.fetchProtype();
    await this.fetchHelpers();
  },
  destroyed() {},
  mounted() {
    window.scrollTo(0, 0);
  },
  beforeUpdate() { 
    console.log('ssssssssss', this.modalShow); 
  },
  computed: {},
};
</script>
<style> 
.thumbnail-img {
  display: block;
  margin-top: 4px;
}
.font-size-20{
  font-size:20px
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-11 {
    width: 91.66666666666666%;
  }
  .col-sm-10 {
    width: 83.33333333333334%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-8 {
    width: 66.66666666666666%;
  }
  .col-sm-7 {
    width: 58.333333333333336%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-5 {
    width: 41.66666666666667%;
  }
  .col-sm-4 {
    width: 33.33333333333333%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-2 {
    width: 16.666666666666664%;
  }
  .col-sm-1 {
    width: 8.333333333333332%;
  }
}
</style>
<style scoped>
.btn-file {
  overflow: hidden;
  position: relative;
  vertical-align: middle;
}
.modal-content.scrollbar-width-thin {
  border: none !important;
}
label {
  display: inline-block;
  margin: 0px 0px 4px 2px;
  float: left;
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  text-align: left;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

/*.svg-inline--fa.fa-random {
  margin: -33px 0px 0px 103px !important;
  background-color: #ccc;
  padding: 9px;
  z-index: 100;
  display: inline-block;
  position: absolute;
  border-radius: 0px 3px 3px 0px;
}*/
.multiselect-tag.is-user {
  padding: 5px 8px;
  border-radius: 22px;
  background: #35495e;
  margin: 3px 3px 8px;
}

.multiselect-tag.is-user img {
  width: 18px;
  border-radius: 50%;
  height: 18px;
  margin-right: 8px;
  border: 2px solid #ffffffbf;
}

.multiselect-tag.is-user i:before {
  color: #ffffff;
  border-radius: 50%;
}

.user-image {
  margin: 0 6px 0 0;
  border-radius: 50%;
  height: 22px;
}
.multiselect-clear {
  display: inline-block !important;
  float: right !important;
}
.multiselect {
  display: block;
  position: relative;
}
.multiselect.is-active {
  z-index: 1;
}

.modal-content.scrollbar-width-thin.product-show-modal {
  width: 700px;
  margin: auto;
}
.modal-content.scrollbar-width-thin.product-upload-modal {
  width: 400px;
}
.modal-content.scrollbar-width-thin.product-add-modal {
  width: 95% !important;
  margin: 0px auto;
  min-width: 500px;
}
.modal-content.scrollbar-width-thin.product-barcode-modal {
  max-width: 900px;
  min-width: 800px;
  margin: 0px auto;
}
</style>
<style src="@vueform/multiselect/themes/default.css"></style>
